<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">


        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Recover your password</h4>
                                    <p>Please enter your email address and we'll send you instructions on how to reset your password.</p>
                                </div>

                                <div>
                                <vs-input v-validate="'required|email'" data-vv-validate-on="blur" name="email" type="email" label-placeholder="Email" v-model="user.email" class="w-full mb-8" />
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>
                                </div>
                                <br/>
                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                                <vs-button class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0" @click="handleForgot">Recover Password</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>

import User from '@/models/user'

export default {
  name: 'Forgot',
  data () {
    return {
      user: new User('', '', '')
    }
  },
  methods: {
    handleForgot () {
      this.message = ''
      this.submitted = true
      this.$validator.validate().then(isValid => {
        if (isValid) {
          this.$store.dispatch('auth/forgot', this.user).then(
            data => {
              let color_val = 'success'
              let title_val = 'Success'
              let message = data.message
              if (data.code !== 200) {
                color_val = 'danger'
                title_val = 'Error'
                message = 'Error reseting the password.'
              }
              this.$vs.notify({
                'time':10000,
                'title': title_val,
                'text': message,
                'color': color_val
              })
            },
            error => {
              this.$vs.notify({
                'time':10000,
                'title':'Error',
                'text':error.message,
                'color':'danger'
              })
            }
          )
        }
      })
    }
  }
}
</script>
